var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__a)",
    d: "M12.085 5.418c1 0 1.615-1.092 1.099-1.948a1.42 1.42 0 0 0-1.84-.549l-.051.03c-1.15.696-.645 2.467.7 2.467z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__b)",
    d: "M6.01 5.418a.57.57 0 0 0 .304-.086c.564-.35 2.716-1.688 3.921-2.431.397-.245.47-.86.138-1.188A1.38 1.38 0 0 0 8.43 1.7l-2.821 2.72a.58.58 0 0 0 .402.997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__c)",
    d: "M17.017 9.981h-3.821a1.814 1.814 0 0 0 0 3.628h3.82a.796.796 0 0 0 .796-.796V10.78a.797.797 0 0 0-.796-.799m-3.023 1.597a.298.298 0 0 1 0 .594.297.297 0 0 1 0-.594"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#wallet_svg__d)",
    d: "M13.196 14.203c-3.187-.12-3.184-4.696 0-4.816h2.488a.594.594 0 0 0 .594-.594V7.496a1.485 1.485 0 0 0-1.485-1.484H2.672a1.485 1.485 0 0 0-1.485 1.484v8.71a1.485 1.485 0 0 0 1.485 1.485h12.121a1.485 1.485 0 0 0 1.485-1.485 2 2 0 0 0-2.004-2.003z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallet_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-7.521 35.65 -78.033)scale(2.69895 1.91784)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallet_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.45969 -.55023 .64189 2.86943 7.536 3.202)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallet_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.43719 -.48547 .50933 2.55696 14.316 11.654)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wallet_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.7194 -1.5629 2.17614 7.9636 8.072 11.397)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })))));
};
export default SvgWallet;